module.exports = __webpack_public_path__ + "img/Portada_MisterGlobaljpg.5417eb2a.jpg";